<div class="btn-group ml-3" btnRadioGroup [(ngModel)]="environment.environment" (ngModelChange)="onEnvChange($event)">
    <label [ngClass]="getEnvButtonClass('test')" btnRadio="test" tabindex="0" role="button">Test</label>
    <label [ngClass]="getEnvButtonClass('production')" btnRadio="production" tabindex="0" role="button">Production</label>
</div>
